// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__12a__","fileBtn":"File_fileBtn__bF3e7","closeBtn":"File_closeBtn__2a9Ul","fileSelected":"File_fileSelected__2Ie7z","disabled":"File_disabled__3Vzfh"};